import Alert, { AlertProps } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import ButtonBase from '@mui/material/ButtonBase';
import Collapse from '@mui/material/Collapse';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import React, { useState } from 'react';
import { IValidation, IValidationData } from './utils';

export interface IValidationPrompter extends AlertProps {
  title?: string;
  messages: IValidation;
}

function Messages(props: {messages: IValidation}) {
  const {messages} = props;
  return (
    <Grid container direction="column" style={{padding: '8px 12px'}}>
      {
        Object.keys(messages).map((key: string) => <Typography
          variant="caption"
          color="textPrimary"
          style={{ marginBottom: 8}}
          key={key}
        >• {key}: {messages[key]}</Typography>)
      }
    </Grid>
  )
}

export function ValidationPrompters(props: {validation: IValidationData; ErrorProps?: IValidationPrompter; WarningProps?: IValidationPrompter}) {
  const {validation, ErrorProps, WarningProps} = {
    ErrorProps: {severity: 'error', title: props.validation.numErrors + ' Errors'},
    WarningProps: {severity: 'warning', title: props.validation.numWarnings + ' Warnings'},
    ...props
  };
  return (
    <React.Fragment>
      <Collapse in={Object.keys(validation.errors).length > 0}>
        <Grid item style={{marginBottom: 12}}>
          <ValidationPrompter {...ErrorProps as any} messages={validation.errors}/>
        </Grid>
      </Collapse>

      <Collapse in={Object.keys(validation.warnings).length > 0}>
        <Grid item style={{marginBottom: 12}}>
          <ValidationPrompter  {...WarningProps as any} messages={validation.warnings}/>
        </Grid>
      </Collapse>
    </React.Fragment>
  )
}

export default function ValidationPrompter(props: IValidationPrompter) {
  const { messages, title } = props;
  const [show, setShow] = useState(false);
  return (
    <Alert severity="warning" style={{ maxWidth: 550, width: '100%' }} {...props}>
      {title && <AlertTitle>{title}</AlertTitle>}

      {/*Collapse not needed if the message size is small*/}
      <Grid container direction="column">

        {
          Object.keys(messages).length > 0 && (
            <Collapse in={show} collapsedSize={40}>
              <Messages messages={messages}/>
            </Collapse>
          )
        }
        {
          Object.keys(messages).length > 1 && (
            <ButtonBase
              onClick={() => setShow(!show)} style={{ width: '100%' }}
            >
              {
                !show
                  ? <KeyboardArrowDownIcon fontSize="inherit"/>
                  : <KeyboardArrowUpIcon fontSize="inherit"/>
              }
            </ButtonBase>
          )
        }
      </Grid>
    </Alert>
  );
}
